import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkDeleteQuoteRequestLineSurfaceTreatments = ClientInferResponseBody<
  typeof contract.quoteRequestLines.bulkDeleteSurfaceTreatments
>;

export type BulkDeleteQuoteRequestLineSurfaceTreatmentsDto = ClientInferRequest<
  typeof contract.quoteRequestLines.bulkDeleteSurfaceTreatments
>["body"];

export const bulkDeleteQuoteRequestLineSurfaceTreatments = async ({
  payload,
}: {
  payload: BulkDeleteQuoteRequestLineSurfaceTreatmentsDto;
}): Promise<BulkDeleteQuoteRequestLineSurfaceTreatments> => {
  const response = await api.quoteRequestLines.bulkDeleteSurfaceTreatments.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Failed to delete quote request line surface treatments",
    response.status,
    response.body,
  );
};
